import React, { useEffect, useState } from 'react';
import { View, Dimensions, StyleSheet } from 'react-native';

export default function useScreenDimensions() {
	const [screenData, setScreenData] = useState(Dimensions.get('window'));

	useEffect(() => {
		const onChange = result => {
			setScreenData(result.window);
		};

		Dimensions.addEventListener('change', onChange);

		return () => Dimensions.removeEventListener('change', onChange);
	});

	return {
		...screenData,
		isLandscape: screenData.width > screenData.height
	};
}
